import React, { useEffect, useState } from "react";
import BarChart from "../../../../CHARTS/BarChart";
import { FaChartBar, FaChartLine } from "react-icons/fa";
import NoDataFound from "../../../../Extra/NoDataFound";
const MachineGraphView = ({ data }) => {
  const [filterData, setFilterData] = useState(null);
  const [barType, setBarType] = useState("bar");
  useEffect(() => {
    if (data && data.length > 0) {
      const filData = data.filter((o) => o.Availed !== "00:00:00");
      const tableData = Object.values(
        filData.reduce((acc, { Block_Type }) => {
          const key = Block_Type?.trim();
          if (!key) return acc;
          acc[key] = acc[key] || {
            name: key,
            value: 0,
            color: "rgba(57, 139, 215, 1)",
          };
          acc[key].value++;
          return acc;
        }, {})
      ).sort((a, b) => b.value - a.value);

      setFilterData(tableData);
    }
  }, [data]);

  return (
    <div className="papaDiv">
      <div className="row">
        <div className="d-flex justify-content-between text-white bg-dark">
          <h5 className="p-1 ">Machine Graph View</h5>
          <div className="d-flex p-1">
            <button
              className={`btn btn-sm btn-outline-light me-1 ${
                barType === "bar" && "active"
              }`}
              onClick={() => setBarType("bar")}
            >
              <FaChartBar />
            </button>
            <button
              className={`btn btn-sm btn-outline-light ${
                barType === "line" && "active"
              }`}
              onClick={() => setBarType("line")}
            >
              <FaChartLine />
            </button>
          </div>
        </div>

        {filterData ? (
          <BarChart data={filterData} type={barType} />
        ) : (
          <NoDataFound />
        )}
      </div>
    </div>
  );
};
export default MachineGraphView;
